import React from "react";

import { ComponentProps } from "@ts/components";

import { ExpandedAsset, IconInstagram, Link, SanityImage } from "@bared/ui";

export type InstagramCardProps = ComponentProps & {
  instagramHandle: string;
  postImage?: ExpandedAsset;
  productHandle?: string;
};

const InstagramCard = ({
  postImage,
  instagramHandle,
  productHandle,
}: InstagramCardProps) => {
  return (
    <div className="px-micro first-of-type:pl-zero md:px-mini">
      {!!productHandle ? (
        <Link variant="plain" href={`/products/${productHandle}`}>
          <div className="relative">
            <IconInstagram className="absolute right-mini top-mini h-mini text-white md:right-midi md:top-midi" />
            <SanityImage
              className="aspect-4-5 object-cover"
              data={postImage}
              maxWidth="100vw"
              altText={instagramHandle}
            />
          </div>
        </Link>
      ) : (
        <div className="relative">
          <IconInstagram className="absolute right-mini top-mini h-mini text-white md:right-midi md:top-midi" />
          <SanityImage
            className="aspect-4-5 object-cover"
            data={postImage}
            maxWidth="100vw"
            altText={instagramHandle}
          />
        </div>
      )}
    </div>
  );
};

export default InstagramCard;
